import React, { useState, useEffect } from 'react'
import { Row, Col, Input, Select, Form, Button, Modal, message } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import '../../Content/content-common.less'
import { axiosPostAndHint } from '../../../components/reqAndHint'
import axios from '../../../utils/AxiosUtil';
import { useSelector } from 'react-redux'
const { Option } = Select;
import { levelObj } from '../../../utils/info';

/**
 * 新建委员页面
 */
export default function add() {
    const langValue = useSelector(state => state.langList.value)
    const [form] = Form.useForm();
    const [AreaOpt, setAreaOpt] = useState([]);

    useEffect(() => {

        getArea();

        return () => {
            setAreaOpt([]);
        }

    }, [])

    const getArea = async () => {
        let data = await axios.post('/fund/area/getAll')
        // console.log('data:', data, 'type:', typeof data);
        if (data ?.data) {
            let areaData = [...data ?.data ?.data];
            setAreaOpt([...areaData]);
        } else {
            message.error('地区查询失败');
        }
    }

    function onFinishFailed({ values, errorFields, outOfDate }) {
        // console.log("addVolunteer form onFinishFailed:", values, errorFields, outOfDate);
        Modal.warn({ title: langValue == 0 ? '志工信息验证未通过，请修改Volunteer information verification failed, please modify' : (langValue == 1 ? '志工信息验证未通过，请修改' : 'Volunteer information verification failed, please modify') });
    }

    function onFinish(values) {
        console.log("addVolunteer form onFinish:", values);
        let { firstName, middleName, surName } = values;
        let en_name = firstName ?.trim() + (middleName ? ` ${middleName.trim()}` : '') + ` ${surName}`;
        values.en_name = en_name;
        axiosPostAndHint('/volunteer/add', values, () => {
            document.getElementById('/view/volunteer/list') ?.click();
        });
    }

    return (
        <div className="add-volunteer">
            <Form
                name="add-volunteer"
                form={form}
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                initialValues={{ volunteerStatus: 'on', gender: '男' }}
            // onValuesChange={onValChange}
            >
                <div className='volunteer-info'>
                    <h1 className="info-title">{langValue == 0 ? '新建志工New Volunteer' : (langValue == 1 ? '新建志工' : 'New Volunteer')}</h1>
                    <div className='info-content' style={{ marginLeft: 24 }}>
                        <Row gutter={[2, { xs: 1, sm: 2, md: 3, lg: 4 }]} sytle={{ 'width': '60%' }}>

                            <Col className="gutter-row" span={6}>
                                <div className="input-wrapper">
                                    <label htmlFor="area">{langValue == 0 ? '地区Region' : (langValue == 1 ? '地区' : 'Region')}：</label>
                                    <Form.Item
                                        name="area"
                                        rules={[{ required: true, message: '请选择地区Please select' }]}
                                    >
                                        <Select
                                            showSearch
                                            placeholder={langValue == 0 ? '请选择地区(Please select region)：' : (langValue == 1 ? '请选择地区：' : 'Please select region:')}
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {AreaOpt.map(a => (
                                                <Option value={a.areaCode} key={a.areaCode}>{a.area}</Option>
                                            ))}

                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>

                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="volunteerCode"
                                    rules={[{ required: true, message: '请输入志工编号Please enter' }]}
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="volunteerCode">{langValue == 0 ? '志工编号Commissioner Number' : (langValue == 1 ? '志工编号' : 'Commissioner Number')}：</label>
                                        <Input id="volunteerCode" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>

                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="volunteerName"
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="volunteerName">{langValue == 0 ? '中文名Chinese Name' : (langValue == 1 ? '中文名' : 'Chinese Name')}：</label>
                                        <Input id="volunteerName" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="firstName"
                                    rules={[{ required: true, message: '请输入Please enter' }]}
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="firstName">{langValue == 0 ? '英文名First Name' : (langValue == 1 ? '英文名' : 'First Name')}：</label>
                                        <Input id="firstName" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="middleName"
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="middleName">{langValue == 0 ? '英文中名Middle Name' : (langValue == 1 ? '英文中名' : 'Middle Name')}：</label>
                                        <Input id="middleName" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="surName"
                                    rules={[{ required: true, message: '请输入Please enter' }]}
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="surName">{langValue == 0 ? '英文姓Surname' : (langValue == 1 ? '英文姓' : 'Surname')}：</label>
                                        <Input id="surName" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>

                            <Col className="gutter-row">
                                <div className="input-wrapper">
                                    <label htmlFor="gender">{langValue == 0 ? '性别Gender' : (langValue == 1 ? '性别' : 'Gender')}：</label>
                                    {/* 换行 */}
                                    <div></div>
                                    <Form.Item
                                        name="gender"
                                        rules={[{ required: true, message: '请选择性别' }]}
                                    >
                                        <Select placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} style={{ width: 120 }} >
                                            <Option value="男" key="男">{langValue == 0 ? '男/Male' : (langValue == 1 ? '男' : 'Male')}</Option>
                                            <Option value="女" key="女">{langValue == 0 ? '女/Female' : (langValue == 1 ? '女' : 'Female')}</Option>
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <div className="input-wrapper">
                                    <label htmlFor="level">{langValue == 0 ? '身份Identity' : (langValue == 1 ? '身份' : 'Identity')}：</label>
                                    {/* 换行 */}
                                    <div></div>
                                    <Form.Item
                                        name="level"
                                        rules={[{ required: true, message: '请选择级别' }]}
                                    >
                                        <Select placeholder={langValue == 0 ? '请选择Please select' : (langValue == 1 ? '请选择' : 'Please select')} >
                                            {levelObj.map((item, index) => {
                                                return (
                                                    <Option value={index} key={index}>{langValue == 0 ? (item.label + item.en_label) : (langValue == 1 ? item.label : item.en_label)}</Option>
                                                )
                                            })}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="phone"
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="phone">{langValue == 0 ? '电话Telephone No.' : (langValue == 1 ? '电话' : 'Telephone No.')}：</label>
                                        <Input id="phone" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>

                            <Col className="gutter-row" span={6}>
                                <Form.Item
                                    name="idCard"
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="idCard">{langValue == 0 ? '证件号ID Number' : (langValue == 1 ? '证件号' : 'ID Number')}：</label>
                                        <Input id="idCard" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>

                            <Col className="gutter-row" span={6}>
                                <div className="input-wrapper">
                                    <label htmlFor="volunteerStatus">{langValue == 0 ? '状态Status' : (langValue == 1 ? '状态' : 'Status')}</label>
                                    {/* 换行 */}
                                    <div></div>
                                    <Form.Item
                                        name="volunteerStatus"
                                    >
                                        <Select style={{ width: 120 }} >
                                            <Option value="on" key="on" >{langValue == 0 ? '启用/Active' : (langValue == 1 ? '启用' : 'Active')}</Option>
                                            <Option value="off" key="off">{langValue == 0 ? '停用Inactive' : (langValue == 1 ? '停用' : 'Inactive')}</Option>
                                        </Select>
                                    </Form.Item>
                                </div>
                            </Col>

                            {/* <Col className="gutter-row" span={6}>
                            </Col> */}

                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    name="address"
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="address">{langValue == 0 ? '地址Address' : (langValue == 1 ? '地址' : 'Address')}：</label>
                                        <Input id="address" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>

                            <Col className="gutter-row" span={6}>
                            </Col>

                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    name="remark"
                                >
                                    <div className="input-wrapper">
                                        <label htmlFor="remark">{langValue == 0 ? '备注Remarks' : (langValue == 1 ? '备注' : 'Remarks')}：</label>
                                        <Input id="remark" placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} className="u-input" />
                                    </div>
                                </Form.Item>
                            </Col>

                        </Row>
                    </div>
                </div>

                <div style={{ marginLeft: 24 }}>
                    <Button type="primary" htmlType="submit">
                        {langValue == 0 ? '确定提交Confirm and Submit' : (langValue == 1 ? '确定提交' : 'Confirm and Submit')}
                    </Button>
                </div>
            </Form>
        </div >
    )
}

